export const find = ( arr, value, predicate ) => {
  if ( arr && predicate && predicate.apply ) {
    for ( let i = 0; i < arr.length; i++ ) {
      if ( value === predicate( arr[i] ) ) {
        return i;
      }
    }
  }
  return -1;
};

export const flattenTree = ( childProperty, hasChildProperty, arrayProperty, ...parents ) => ( item, transform ) => {
  let results = [];
  if ( !item ) {
    return results;
  }
  if ( Array.isArray( item[arrayProperty] ) ) {
    results = transform && transform.apply && transform( item[arrayProperty], ...parents ) || item[arrayProperty]
  }
  if ( item[hasChildProperty] && Array.isArray( item[childProperty] ) ) {
    results = results.concat(item[childProperty].reduce( ( current, child ) => current.concat( flattenTree( childProperty, hasChildProperty, arrayProperty, ...parents, child )( child, transform ) ), [] ));
  }
  return results;
};

export const replace = ( arr, newItem, predicate ) => {
  let value = predicate( newItem );
  let index = find( arr, value, predicate );
  return index < 0 ? [...arr, newItem] : [...arr.slice( 0, index ), newItem, ...arr.slice( index + 1 )];
};

export const remove = ( arr, item, predicate ) => {
  if ( arr && predicate && predicate.apply ) {
    let value = predicate( item );
    let index = find( arr, value, predicate );
    return index < 0 ? [...arr] : [...arr.slice( 0, index ), ...arr.slice( index + 1 )];
  }
  return null;
};

export const any = ( arr, predicate ) => {
  if ( !predicate && arr && arr.length > 0 ) {
    return true;
  }
  for ( let item of arr ) {
    if ( predicate( item ) ) {
      return true;
    }
  }
  return false;
};

export const all = ( arr, predicate ) => {
  if ( !predicate || !predicate.call ) {
    throw 'All cannot be called without a predicate';
  }
  for ( let item of arr ) {
    if ( !predicate( item ) ) {
      return false;
    }
  }
  return true;
};

export const none = ( arr, predicate ) => {
  return !any( arr, predicate );
};

export const where = function *( arr, predicate ) {
  for ( let item of arr ) {
    if ( predicate( item ) ) {
      yield item;
    }
  }
};

export const firstOrDefault = ( arr, predicate ) => {
  if ( !arr ) {
    return null;
  }
  if ( !predicate || !predicate.apply ) {
    return arr[0] || null;
  }
  if ( !predicate && arr && arr.length > 0 ) {
    return arr[0];
  }
  for ( let item of arr ) {
    if ( predicate( item ) ) {
      return item;
    }
  }
  return null;
};

export const first = ( arr, predicate ) => {
  let item = firstOrDefault( arr, predicate );
  if ( item === null ) {
    throw 'Sequence doesn\'t contain any matching elements';
  }
  return item;
};

export const select = ( arr, transformation = t => t ) => 
  arr.map( transformation );
  
export const orderBy = ( arr, orderValue = i => i ) =>
  [...arr].sort( ( a, b ) => orderValue( a ) > orderValue( b ) ? 1 : -1 );
  
export const descending = ( arr, isDescending = true ) => isDescending ? [...arr].reverse() : [...arr];
  
export const count = ( arr, predicate ) => {
  if ( !predicate ) {
    return arr.length;
  }
  return where( arr, predicate ).count();
};

export const peek = ( arr ) => {
  if ( !Array.isArray( arr ) ) {
    return undefined;
  }
  return arr[arr.length - 1];
}